<template>
  <div class="index">
    <navi :activeIndex="4"></navi>
    <div class="container">
      <div class="left">
        <img src="@/assets/gsjs_01.jpg" alt="">
      </div>
      <div class="right">
        <div class="t1">厦门游仁信息科技有限公司</div>
        <div class="t2">成立于2014 年</div>
        <div class="t2">具有大型3D多人高难度端游技术背景</div>
        <div class="t3">4年VR及AR技术积累</div>
        <div class="t3">3年VR驾培行业积累</div>
        <div class="t3">2018年主导落地全球第一个20台规模商业化VR驾培中心</div>
        <div class="t3">2019年初进行福州全城VR驾驶网点布设，</div>
        <div class="t3">&nbsp已成功落地福州软件园与福州大学核心宿舍区</div>
        <div class="t3">2019年6月游仁VR学车中心于宁德师院开设</div>
        <div class="t3">2019年8月游仁VR学车中心于宁德新能源宿舍区开设</div>
      </div>
    </div>
  </div>
</template>

<script>
import Navi from "./Navi.vue";
export default {
  name: "AboutUs",
  components: {
    Navi
  },
  data() {
    return {};
  },
  created() {},
  methods: {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.index {
  /* background-color: rgb(43, 43, 51); */
}

.container {
  box-shadow: 0px 0px 6px #999;
  width: 1380px;
  height: 900px;
  margin: 40px auto;
  display: flex;
}

.left {
  width: 560px;
  display: inline-block;
}

.right {
  flex: 1;
  text-align: left;
  line-height: 47px;
}

.left img {
  margin-top: 300px;
}

.t1 {
  color: #666;
  margin-top: 200px;
  font-weight: 800;
  font-size: 28px;
  line-height: 60px;
}

.t2 {
  color: #666;
  font-size: 22px;
}

.t3 {
  font-size: 22px;
  color: #ea6841;
}
@media only screen and (max-width: 800px) {
  .container {
    width: auto;
    margin: 60px 30px;
    box-shadow: 0px 0px 0px #999;
    display: block;
  }
  .left {
    width: 100%;
    display: block;
  }
  img {
    width: 50%;
    margin-top: 0px !important;
  }
  .t1 {
    margin-top: 50px;
    /* text-align: center; */
  }
  /* .t2 {
    text-align: center;
  }
  .t3 {
    text-align: center;
  } */
}
</style>



// WEBPACK FOOTER //
// src/components/AboutUs.vue